import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { SatisfactionService } from 'src/app/services/satisfaction-services/satisfaction-service/satisfaction.service';
import { tap } from 'rxjs/operators';
import * as moment from 'moment/moment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-satisfaction-dashboard',
  templateUrl: './satisfaction-dashboard.component.html',
  styleUrls: ['./satisfaction-dashboard.component.scss']
})
export class SatisfactionDashboardComponent implements OnInit, OnDestroy {

  satisfactions;
  getSatisfactionsSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private satisfactionService: SatisfactionService) { }

  ngOnInit() {
    this.getSatisfactionsList(moment().startOf('day').valueOf(), moment().valueOf());
    this.setBreadcrumb();
  }

  private getSatisfactionsList(from, to) {
    this.getSatisfactionsSubscription = this.satisfactionService.getSatisfactionsList(from, to).pipe(
      tap(o => this.satisfactions = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-star-half-alt', 'satisfactions-page.satisfaction'));
  }

  ngOnDestroy() {
    if (this.getSatisfactionsSubscription) { this.getSatisfactionsSubscription.unsubscribe(); }
  }
}
